"use client";const e=(e,r)=>Object.fromEntries(Object.entries(e).filter((e=>{let[t]=e;return Array.isArray(r)?r.every((e=>e!==t)):t!==r})));export{e as default};
